import { CanActivateFn } from '@angular/router';
import {inject} from '@angular/core';
import {UserService} from '../services/user.service';

export const isActiveGuard: CanActivateFn = (route, state) => {
  const userService = inject(UserService);

  return userService.getUser()?.isActive || !userService.getUser()?.tenantLocked;
};
